import React from 'react';
import { StyleSheet, View } from 'react-native';

import { DisplayText, MobileHeader, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountScreenTitle = (props: Props) => {
  const { testID, visibility = 'ALWAYS', title } = props;

  const { currentBreakpoint } = useResponsive();

  // ─────────────────────────────────────────────────────────────────────

  if (currentBreakpoint.isXS) {
    return <MobileHeader testID={testID} title={title} />;
  }

  if (visibility === 'COMPACT') {
    return null;
  }

  return (
    <View style={styles.row}>
      <DisplayText
        testID={testID}
        // @ts-expect-error TS(2322): Type '{ children: string | undefined; testID: stri... Remove this comment to see the full error message
        accessibilityLevel={1}
        accessibilityRole="header"
        style={styles.regularWidthTitle}
        sizeMatch={['24', '32']}
      >
        {title}
      </DisplayText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  regularWidthTitle: {
    marginBottom: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  title?: string;
  visibility?: 'ALWAYS' | 'COMPACT';
  testID?: string;
};
